import { useTranslation } from "react-i18next";
import React from 'react'

export default function HeaderGeneralIntroduction() {
  const { t } = useTranslation();
  return (
    <button className="w-60 bg-zinc-100" id="login-button" >{t("Đăng nhập 123", "Đăng nhập 123")}</button>
  )
}
